import { useCallback, useMemo } from "react";
import { Option } from "../Option"
import { emptyArray } from "utils/commonHelper";

type Props = {
	selectedItems: any[]
	filteredItems: any[]
	isFiltered: boolean
	onChange(value?: (string | number)[] | undefined): void
	getItemId(item: any): string | number
	disabled: boolean
}

export const SelectAll = ({ selectedItems, filteredItems, isFiltered, onChange, getItemId, disabled }: Props) => {
	const isAllSelected = useMemo(
		() => filteredItems.every(filteredItem => !!selectedItems.find(selectedItem => getItemId(filteredItem) === getItemId(selectedItem))),
		[filteredItems, selectedItems, getItemId]
	)

	const selectAllCallback = useCallback(
		() => {
			if (isAllSelected) {
				// remove everything
				onChange(emptyArray);
			} else {
				// add all filtered items
				onChange([...selectedItems, ...filteredItems]);
			}
		},
		[selectedItems, isAllSelected, onChange, filteredItems]
	)

	if (disabled) {
		return <></>
	}

	return (
		<Option
			key='select_all'
			item={null}
			getItemText={() => isFiltered ? 'i18n.label.selectAllFiltered' : 'i18n.label.selectAll'}
			onClick={selectAllCallback}
			isSelected={isAllSelected}
			// disabled={disabled}
		/>
	)
}
